
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.toggle = document.querySelector('[data-toggle-cart-drawer]');
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.items = this.drawer.querySelector('[data-cart-line-items]');
    this.subtotal = this.drawer.querySelector('[data-cart-subtotal]');
    this.submit = this.drawer.querySelector('[name="checkout"]');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.toggle.addEventListener('click', this.toggleDrawer.bind(this));
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // listen to product form
    document.addEventListener('cart:drawer:open', function() {
      this.renderDrawer();
      this.open();
    }.bind(this));

    // listen to input changes
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.drawer.addEventListener('change', this.debouncedOnChange.bind(this));

    // listen to submit
    this.submit.addEventListener("click", this.onSubmit.bind(this));
  }

  toggleDrawer() {
    if (this.drawer.classList.contains('active')) {
      this.close();
    } else {
      this.renderDrawer();
      this.open();
    }
  }
  

  open() {
    $(".cyc-item-floating-atc-container").hide();
    $("#google-merchantwidget-iframe-wrapper").hide();
    this.drawer.classList.add('animate', 'active');
    document.body.addEventListener('click', this.onBodyClick);
   
  }

  close() {
    $(".cyc-item-floating-atc-container").show();
    $("#google-merchantwidget-iframe-wrapper").show();
    this.drawer.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  renderDrawer() {
    this.renderContents();
    this.updateTotal();
    this.updateCartCount();
    this.updateCartHeaderTotal();
  }

  renderContents() {
    window
      .fetch(`/?section_id=api-cart-items`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        const fresh = document.createElement("div");
        fresh.innerHTML = response;
        this.items.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;

        // init remove
        this.items.querySelectorAll('cart-remove-button').forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.updateQuantity(btn.dataset.index, btn.dataset.key, 0, 'remove');
            $("#cart-status").html(btn.dataset.cyccartstatus);
          });
        })
      });
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.dataset.key, event.target.value, document.activeElement.getAttribute('name'));
    $("#cart-status").html(event.target.dataset.cyccartstatus + ' ' + event.target.value);
  }

  onSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const promises = this.updatePropertiesPromises();
    Promise.all(promises).then(() => {
      window.location.href = "/checkout";
    });
  }


  updateQuantity(line, key, quantity, name) {
    this.enableLoading(line);

    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => {
        return response.json();
      })
      .then(async (data) => {
        const matchKeys = (item) => item.key === key;
        const found = data.items.find(matchKeys);
        const foundPromo = data.items.filter((item) => {
          if (item.properties._promo) {
            const promoCode = item.properties._promo;
            if (promoCode.includes('freeze-c')) {
              const [_, promoId, parentId, qty, secret] = promoCode.match(/freeze-c(\d+)p(\d+)x(\d+)z(\d+)/);
              item["multiplier"] = parseFloat(qty);
              return parseFloat(parentId) === found.product_id;
            }
          }
        });

        const updates = (foundPromo.length && !found.properties._promo) ? [found].concat(foundPromo) : [found];
        const body = updates.reduce((obj, item) => {
          if (item.key !== key) {
            obj[item.key] = item.multiplier ? (item.multiplier * parseFloat(quantity)) : parseFloat(quantity);
          }
          else obj[item.key] = quantity;
          return obj;
        }, {}); 

        const formData = {
          updates: body
        }

        return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(formData),
          }).then((response) => {
            return response.json();
          }).then((state) => {
            this.renderDrawer();
            this.disableLoading(line);
          }).catch(() => {
            console.error(window.cartStrings.error);
            this.disableLoading(line);
          });
      })
      .catch(() => {
        console.error(window.cartStrings.error);
        this.disableLoading(line);
      });
  }

  updatePropertiesPromises() {
    const itemsWithAdditionalRebate = Array.from(this.items.querySelectorAll("[data-cart-additional-rebate]"));
    const additionalRebatePromisesArr = itemsWithAdditionalRebate.map((elem) => {
      return new Promise((resolve, reject) => {
        fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => {
          return response.json();
        })
        .then(async (data) => {
          const matchKeys = (item) => item.key === elem.dataset.key;
          const index = data.items.findIndex(matchKeys);
          const found = data.items.find(matchKeys);

          const properties = found.properties;
          var newProperties = properties;
          const qualifiesForAdditionalRebate = elem.getAttribute("data-cart-additional-rebate");
          if (qualifiesForAdditionalRebate === 'true') {
            newProperties["additional_rebate"] = elem.textContent;
          } else {
            const { additional_rebate, ...rest } = properties;
            newProperties = rest;
          }

          const formData = {
            line: `${index + 1}`,
            quantity: found.quantity,
            properties: newProperties
          }

          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(formData),
          }).then((response) => {
            resolve(response);
          }).catch((error) => {
            reject(error);
          });
        })
        .catch((error) => {
          console.error(error);
        });
      })
    });

    return additionalRebatePromisesArr;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    this.querySelector(`#CartItem-${line} input`).disabled = true;
    this.querySelector(`#CartItem-${line}`).classList.add('is-loading');
    document.activeElement.blur();
  }

  disableLoading(line) {
    this.querySelector(`#CartItem-${line} input`).disabled = false;
  }

  updateTotal() {
    window
      .fetch(`/?section_id=api-cart-subtotal`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        const fresh = document.createElement("div");
        fresh.innerHTML = response;
        this.subtotal.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;
      });
  }

  updateCartCount() {
    window
      .fetch(`/?section_id=api-cart-count`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        const fresh = document.createElement("div");
        fresh.innerHTML = response;

        const cartCountBubble = this.toggle.querySelector('.cart-count-bubble');
        cartCountBubble.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;
      });
  }

  updateCartHeaderTotal() {
    window
      .fetch(`/?section_id=api-cart-subtotal-header`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        const fresh = document.createElement("div");
        fresh.innerHTML = response;

        const cartTotal = this.toggle.querySelector("[data-cart-header-total]");
        cartTotal.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;
      });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.drawer && !target.closest('cart-drawer') && !target.closest('[data-toggle-cart-drawer]')) {
      this.close();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

//ADA focus Trap for drawer.
(function () {
  let trapContainer = null;
  let focusableElements = [];
  let firstFocusable = null;
  let lastFocusable = null;

  function setFocusTrap(container) {
    trapContainer = container;

    focusableElements = trapContainer.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input:not([disabled]), select, [tabindex]:not([tabindex="-1"])'
    );

    focusableElements = Array.from(focusableElements).filter(el =>
      !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')
    );

    firstFocusable = focusableElements[0];
    lastFocusable = focusableElements[focusableElements.length - 1];

    // Move focus into the drawer
    if (firstFocusable) firstFocusable.focus();

    document.addEventListener('keydown', trapTabKey);
  }

  function removeFocusTrap() {
    document.removeEventListener('keydown', trapTabKey);
    trapContainer = null;
  }

  function trapTabKey(e) {
    if (!trapContainer) return;

    if (e.key === 'Tab') {
      if (e.shiftKey) {
        // SHIFT + TAB
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        // TAB
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  }

  // Observe for drawer open/close
  const observer = new MutationObserver(() => {
  const drawer = document.querySelector('[data-cart-drawer].active');

    if (drawer) {
      console.log("CYC FOCUS FIRE");
      setFocusTrap(drawer);
    } else {
      removeFocusTrap();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true, attributes: true });
})();